import { useContext } from 'react';
import { UserConsent } from './useUserConsent.types';
import { UserConsentContext } from './UserConsent.provider';

/**
 * !! DON'T USE THIS HOOK DIRECTLY IN CODE !!
 *
 * Use like:
 * ```ts
 * const [isUserConsentEnabled, isLoadingUserConsent, setUserConsent] = useIsFeatureEnabled({ consentKey: '{{consentKey}}' });
 * ```
 *
 * Hook to access user consent state and actions.
 *
 * This hook must be used within a `UserConsentProvider` context provider,
 * otherwise it will throw an error.
 *
 * @returns {UserConsent} An object containing:
 *  - `getUserConsent`: function to get consent answer (boolean or undefined) by key
 *  - `setUserConsent`: async function to update consent answer by key
 *  - `loadingUserConsent`: boolean indicating if consent data is loading
 *
 * @throws Will throw an error if used outside of `UserConsentProvider`.
 */
export const useUserConsent = (): UserConsent => {
  const context = useContext(UserConsentContext);
  if (!context) {
    throw new Error('useUserConsent must be used within a UserConsentProvider');
  }
  return context;
};
